import { loadCombinedTranslations } from '~/assets/translation'

export default async (context, locale) => {
  return await loadCombinedTranslations(context, locale)
}
